import React from "react";
import LegalLayout from "./LegalLayout";

export default function Support() {
  return (
    <LegalLayout title="お問い合わせ・サポート">
      <h2>サポート</h2>
      <p>DressWorkに関するご質問やお困りのことがございましたら、下記のメールアドレスまでお気軽にお問い合わせください。</p>
      
      <h2>お問い合わせ先</h2>
      <p><strong>メール：</strong><a href="mailto:gk3gogogo@gmail.com" style={{color:"#d4af6e"}}>gk3gogogo@gmail.com</a></p>
      <p>通常、1〜2営業日以内にご返信いたします。</p>

      <h2>よくあるご質問</h2>
      <p><strong>Q. 利用料はかかりますか？</strong></p>
      <p>A. いいえ、DressWorkの利用は完全無料です。ダウンロードから求人紹介まで、費用は一切かかりません。</p>

      <p><strong>Q. 退会したい場合はどうすればいいですか？</strong></p>
      <p>A. アプリ内のチャット画面右上のメニューから「退会する」を選択してください。アカウントと全てのデータが削除されます。</p>

      <p><strong>Q. 個人情報は安全ですか？</strong></p>
      <p>A. お預かりした情報は厳重に管理し、求人紹介の目的以外には一切使用しません。詳しくはプライバシーポリシーをご確認ください。</p>

      <p><strong>Q. 紹介されたお店を断ることはできますか？</strong></p>
      <p>A. もちろんです。ご紹介した求人に必ず応募する必要はありません。</p>

      <p className="dw-legal__company">合同会社GK3</p>
    </LegalLayout>
  );
}
